import React from 'react';
import { Tag, List, Icon } from 'antd';
import { Link } from 'react-router-dom';
import { css } from '@emotion/css';

const ratings = css`
	border: 0;
	color: #8c8c8c;
`;

const listItem = css`
	background: white;
	margin-bottom: 10px;
	padding: 10px !important;
	border: 1px solid #eaeaea !important;

	.ant-list-item-meta-title {
		margin-bottom: 0 !important;
		overflow: hidden;
		max-width: calc(${window.screen.availWidth}px - 125px);
	}

	.ant-list-item-meta-description {
		overflow: hidden;
		max-width: calc(${window.screen.availWidth}px - 125px);
	}
	&:hover {
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
	}
`;

/*
	To generate list Layout we are using List Component of ant design.
*/

const HorizontalCard = ({ results }) => (
	<List
		itemLayout="vertical"
		dataSource={results}
		renderItem={item => (
			<Link to={`/book/${item._id}`} key={item._id}>
				<List.Item
					className={listItem}
					key={item.title}
					extra={<img width={70} alt={item.original_title} src={item.image} />}
				>
					<List.Item.Meta
						title={item.original_title}
						description={
							<React.Fragment>
								<p>
									{item.authors.join(', ')}
									<br />
									<Icon
										type="calendar"
										style={{ color: 'rgba(0, 0, 0, 0.45)', marginRight: 5 }}
									/>
									<strong>{item.original_publication_year}</strong>
								</p>
								<Tag color="#f5f5f5" className={ratings}>
									<Icon type="star" theme="filled" style={{ color: '#faad14' }} />{' '}
									{item.average_rating}
								</Tag>
							</React.Fragment>
						}
					/>
				</List.Item>
			</Link>
		)}
	/>
);

export default HorizontalCard;
